import { useState } from 'react';
import { ConfigProvider, Layout, Tabs } from 'antd';
import { TripScheduling, TripStartEnd } from './tabs';
import './TripSchedulingAndManagement.css';

const { Content } = Layout;

function TripSchedulingAndManagement() {
  const [activeKey, setActiveKey] = useState('1');
  return (
    <ConfigProvider
      theme={{
        components: {
          Typography: {
            titleMarginBottom: 0,
            titleMarginTop: 0,
          },
          Layout: {
            siderBg: 'var(--secondary-fill-color, #2E3033)',
            headerBg: 'transparent',
            headerPadding: '0',
          },
          Form: {
            labelColonMarginInlineEnd: 0,
            labelColonMarginInlineStart: 0,
          },
        },
        token: {
          fontSize: '0.875rem',
        },
      }}
    >
      <Layout className="layout-page">
        <Content className="full-height">
          <Tabs
            type="card"
            size="large"
            className="full-height page-tabs"
            tabBarGutter="2rem"
            tabBarStyle={{
              padding: '0 1rem',
            }}
            destroyOnHidden={true}
            defaultActiveKey="1"
            activeKey={activeKey}
            items={[
              {
                key: '1',
                label: 'Trip Scheduling and Start',
                children: <TripScheduling />,
              },
              {
                key: '2',
                label: 'Trip End',
                children: <TripStartEnd type="end" />,
              },
            ]}
            onChange={activeKey => setActiveKey(activeKey)}
          />
        </Content>
      </Layout>
    </ConfigProvider>
  );
}

export default TripSchedulingAndManagement;
